<template>
  <div id="ponto-interesse-edit"> 
    <div class="vx-row">
        <div class="vx-col w-1/2">
            <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>           
           
            <vs-card class="p-1">  
                <h5 class="mt-2">Relatório: {{data_local.descricaoNomeRelatorio}} </h5>   
                <div class="vx-row">
                    <div class="vx-col w-1/2" > 
                        <div class="flex items-center mt-2">                 
                            <h6 class="mt-2">Nome</h6>  
                        </div>
                    </div>
                    <div class="vx-col w-1/2" > 
                        <div class="flex items-center mt-2">                 
                            <h6 class="mt-2">Enviar às (hh:mm)</h6>  
                        </div>
                    </div>
                    </div>
                    <div class="vx-row">
                    <div class="vx-col w-1/2" > 
                        <div class="flex items-center mt-2">                                 
                            <vs-input v-model="data_local.nome" class="w-full"/>       
                        </div>
                    </div>
                    <div class="vx-col w-1/2" > 
                        <div class="flex items-center mt-2">                 
                            <flat-pickr v-model="data_local.horaGeracao" :config="timePicker"/>            
                        </div>
                    </div>
                </div>                          
                <h6 class="mt-2">Periodização a cada </h6>
                <div class="vx-row">
                    <div class="vx-col w-3/4">
                        <div class="flex items-center mt-2">                    
                            <vue-autonumeric class="vs-inputx vs-input--input hasValue  normal" v-model="data_local.passoRepeticao" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'0' }]"></vue-autonumeric>
                            <v-select                   
                                :reduce="tipo => tipo.data" 
                                :options="listaOpcoesPeriodizacao" 
                                v-model="data_local.periodicidadeRepeticao"       
                                :clearable="false"
                                class="v-select ml-2 normal w-full"></v-select> 
                        </div>
                    </div>  
                    
                </div>   
                <div class="vx-row mt-2 mb-2" v-if="data_local.periodicidadeRepeticao === 'MENSAL'">
                    <div class="vx-col w-1/2">  
                        <div class="flex items-center mt-2">
                            <p style="white-space: nowrap" class="mr-2"> no dia </p>   
                            <vs-input  class="ml-3" type="number"  v-model="data_local.programadoDia" />                                     
                        </div>
                    </div>                                      
                </div>
                <h6 class="mt-2">E repetir </h6>        
                <div class="vx-row mt-2 mb-2" v-if="data_local.periodicidadeRepeticao === 'SEMANAL'">
                    <div class="vx-col w-full" >  
                        <div class="flex items-center">                    
                            <vs-checkbox v-model="data_local.programadoSegunda">Segunda</vs-checkbox>
                            <vs-checkbox v-model="data_local.programadoTerca">Terça</vs-checkbox>
                            <vs-checkbox v-model="data_local.programadoQuarta">Quarta</vs-checkbox>
                            <vs-checkbox v-model="data_local.programadoQuinta">Quinta</vs-checkbox>
                            <vs-checkbox v-model="data_local.programadoSexta">Sexta</vs-checkbox>
                        </div>
                    </div>                  
                </div>
                <div class="vx-row mt-2 mb-2" v-if="data_local.periodicidadeRepeticao === 'SEMANAL'">
                    <div class="vx-col w-full" >  
                        <div class="flex items-center mt-2">
                            <vs-checkbox v-model="data_local.programadoSabado">Sábado</vs-checkbox>
                            <vs-checkbox v-model="data_local.programadoDomingo">Domingo</vs-checkbox>
                        </div>
                    </div>                  
                </div>
                <h6 class="mt-2">Até o dia </h6>        
                <div class="vx-row mt-2 mb-2">
                    <div class="vx-col w-1/2" > 
                        <div class="flex items-center">                     
                            <flat-pickr v-model="data_local.repetirAte" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
                            <vs-button size="small" @click="data_local.repetirAte = null" color="warning" icon-pack="feather" icon="icon-delete" class="ml-2" v-if="data_local.repetirAte"></vs-button>                
                        </div>
                    </div>            
                </div>

                <h6 class="mt-2">Destinatários </h6>        
                <div class="vx-row mt-2 mb-2">
                <div class="vx-col w-1/2" > 
                    <vs-input v-model="data_local.email1Destinatario" placeholder="Destinatário 1"/>   
                </div>
                <div class="vx-col w-1/2" > 
                    <vs-input v-model="data_local.email2Destinatario" placeholder="Destinatário 2"/>   
                </div>
                </div>
                <div class="vx-row mt-2 mb-2">
                <div class="vx-col w-1/2" > 
                    <vs-input v-model="data_local.email3Destinatario" placeholder="Destinatário 3"/>   
                </div>
                <div class="vx-col w-1/2" > 
                    <vs-input v-model="data_local.email4Destinatario" placeholder="Destinatário 4"/>   
                </div>
                </div>
                <div class="vx-row mt-2 mb-2">
                <div class="vx-col w-1/2" > 
                    <vs-input v-model="data_local.email5Destinatario" placeholder="Destinatário 5"/>   
                </div>
                <div class="vx-col w-1/2" > 
                    <vs-input v-model="data_local.email6Destinatario" placeholder="Destinatário 6"/>   
                </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full flex">  
                        <vs-button class="mt-2" size="small" @click="gravar" :disabled="!temPermissaoGravar && !temCapacidadeMaster" color="success">{{ $t('Btn_Gravar') }}</vs-button>
                        <vs-button class="ml-4 mt-2" size="small" @click="excluir" :disabled="!temPermissaoGravar && !temCapacidadeMaster" v-show="isDeletable" color="danger">{{ $t('Btn_Excluir') }}</vs-button>            
                        <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">{{ $t('Btn_Voltar') }}</vs-button>             
                    </div>
                </div> 
            </vs-card>
        </div>
        
    </div>  
  </div>
</template>

<script>
import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import { CONSTANTE_OPCAO_PERIODIZACAO } from '@/constantesComboBox.js'

const URL_SERVLET = "/rest/AgendadorRelatorios";
const NAME_ROUTE_SEARCH = "configuracao-agendador-relatorios";



export default {   
  components: {    
    flatPickr,  
    VueAutonumeric    
  },  
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
            return { 
                    programadoSegunda: false, programadoTerca: false,  programadoQuarta: false, programadoQuinta: false, programadoSexta: false,
                    programadoSabado: false, programadoDomingo: false, repetirAte: null, periodicidadeRepeticao: 'SEMANAL', passoRepeticao: 1,
                    programadoDia: null, horaGeracao: null, nome: null, email1Destinatario: null, email2Destinatario: null, email3Destinatario: null,
                    email4Destinatario: null, email5Destinatario: null, email6Destinatario: null
             }
       }
    },
  },
  created() {
      this.listaOpcoesPeriodizacao = CONSTANTE_OPCAO_PERIODIZACAO; 
  },
  data() {
    return {           
        timePicker: {          
          dateFormat: "H:i",
          enableTime: true,          
          altInputClass: "vs-inputx vs-input--input normal hasValue small text-center w-full",
          locale: PortugueseLocale,  
          noCalendar: true
        },    
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)),
        publicPath: process.env.BASE_URL,                        
        totalRegistros: 0,        
        configDatePicker: {          
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d", 
            altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
            locale: PortugueseLocale
        }        
    }
  }, 
  mounted() {            
    this.findById(); 
  },
  computed: {   
    temCapacidadeMaster(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.capacidadeMaster;
      }
      return false;
    },
    temPermissaoGravar(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.grupoPodeSeAlterar;
      }
      return false;
    },
    isAcessoMaster() {
        return this.$store.getters.isAcessoMaster;
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    },   
    
    validateForm() {
      return !this.errors.any()
    },
    isDeletable() {
       return this.registroOriginal != null && this.registroOriginal.hasOwnProperty("id");
    },       
  },
  methods: {       
    excluir() {
        this.$vs.loading();  
        const params = new URLSearchParams();        
        params.append('outputFormat', 'JSON');
        params.append('id', this.data_local.id);   
        params.append('idCliente', this.$store.state.AppActiveUser.id);    
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);        
                
        axios.post(URL_SERVLET+'/Remover', params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                if (response.data.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();  
            const params = new URLSearchParams();        
            params.append('idCliente', this.$store.state.AppActiveUser.id);
            params.append('id', this.data_local.id);   
            params.append('nome', this.data_local.nome);
            params.append('horaGeracao', this.data_local.horaGeracao);    
            params.append('periodicidadeRepeticao', this.data_local.periodicidadeRepeticao);   
            params.append('passoRepeticao', this.data_local.passoRepeticao);   
            if (this.data_local.repetirAte) {
                params.append('repetirAte', this.data_local.repetirAte); 
            }
            
            if (this.data_local.periodicidadeRepeticao === 'SEMANAL') {
                params.append('programadoSegunda', this.data_local.programadoSegunda);          
                params.append('programadoTerca', this.data_local.programadoTerca);          
                params.append('programadoQuarta', this.data_local.programadoQuarta);          
                params.append('programadoQuinta', this.data_local.programadoQuinta);          
                params.append('programadoSexta', this.data_local.programadoSexta);          
                params.append('programadoSabado', this.data_local.programadoSabado);          
                params.append('programadoDomingo', this.data_local.programadoDomingo);          
            } else {
                params.append('programadoDia', this.data_local.programadoDia);  
            }

            params.append('email1Destinatario', this.data_local.email1Destinatario);
            if (this.data_local.email2Destinatario) {
            params.append('email2Destinatario', this.data_local.email2Destinatario);
            }
            if (this.data_local.email3Destinatario) {
            params.append('email3Destinatario', this.data_local.email3Destinatario);
            }
            if (this.data_local.email4Destinatario) {
            params.append('email4Destinatario', this.data_local.email4Destinatario);
            }
            if (this.data_local.email5Destinatario) {
            params.append('email5Destinatario', this.data_local.email5Destinatario);
            }
            if (this.data_local.email6Destinatario) {
            params.append('email6Destinatario', this.data_local.email6Destinatario);
            }
                    
            axios.post(URL_SERVLET + "/Alterar", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/login' });
                } else {
                    if (response.data.Resultado.hasOwnProperty("error")) {
                            this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Resultado.error, acceptText: 'OK'})
                    } else {
                        this.$router.push({ name: NAME_ROUTE_SEARCH })
                    }                 
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }
         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];

        if (!this.data_local.nome) {
            this.errorsValidacao.push("Nome" + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.horaGeracao) {
            this.errorsValidacao.push("Horário de Geração" + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.periodicidadeRepeticao) {
            this.errorsValidacao.push("Periodicidade de Repetição" + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.passoRepeticao) {
            this.errorsValidacao.push("Informe o passo para periodização da roteirização.");
        }

        if (this.data_local.periodicidadeRepeticao === 'SEMANAL') {
            if (!this.data_local.programadoSegunda && !this.data_local.programadoTerca && !this.data_local.programadoQuarta && !this.data_local.programadoQuinta 
            && !this.data_local.programadoSexta && !this.data_local.programadoSabado && !this.data_local.programadoDomingo ) {
                this.errorsValidacao.push("Selecione pelo menos um dia da semana.");
            }
        } else {
            if (!this.data_local.programadoDia) {
                this.errorsValidacao.push("Informe o dia programado.");
            }
        }

        if (!this.data_local.email1Destinatario) {
            this.errorsValidacao.push("Email do Destinatário 1" + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }
        
        if (!this.errorsValidacao.length) {
            return true;
        }   
        
      return false;
      
    },
    getCorMensagem(texto) {
      if (texto && texto.indexOf("sucesso") != -1) {
        return "success";
      } else {
        return "danger";
      }
    },
    findById() {
        
        const params = new URLSearchParams();        
        params.append('id', this.data_local.id);      
        params.append('idCliente', this.$store.state.AppActiveUser.id);     
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa); 
                
        axios.post(URL_SERVLET + "/Recuperar", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {            
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.AgendadorRelatorios;                             
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }    
  }
}
</script>